<template>
  <v-dialog dark v-model="dialog" full-width>

    <template v-if="!id" v-slot:activator="{ on }">
      <v-btn color="green" dark fab fixed bottom right v-on="on">
        <v-icon>add</v-icon>
      </v-btn>
    </template>

    <template v-else v-slot:activator="{ on }">
      <v-btn icon flat color="white" v-on="on">
        <v-icon>more_vert</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="headline" primary-title>{{dialogTitle}} Saver</v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm6 md4>
              <v-text-field v-model="$data._title" label="Title*" required></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="$data._total"
                prefix="CHF"
                label="Totale da risparmiare*"
                type="number"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-select
                v-model="$data._step"
                prefix="CHF"
                :items="[10, 20, 50, 100, 200]"
                label="Quanto per volta?*"
                required
              ></v-select>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="$data._saved"
                prefix="CHF"
                label="Totale risparmiato*"
                type="number"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
        <small>*campi obbligatori</small>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-btn v-if="id" color="error" flat @click="deleteSaver">Elimina</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="dialog = false">Annulla</v-btn>
        <v-btn color="primary" flat @click="save">Salva</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "settingDialog",
  props: {
    id: String
  },
  data() {
    return {
      dialog: false,
      dialogTitle: "Add",
      _title: '',
      _total: '',
      _saved: '',
      _step: ''
    };
  },
  mounted() {
    this.dialogTitle = this.id != undefined ? "Edit" : "Add";
    if (this.id != undefined) {
        let saver = this.$store.getters.saverSet.find(s=>s.id==this.id)
        this.$data._title=saver.title
        this.$data._total=saver.total
        this.$data._saved=saver.saved
        this.$data._step=saver.step
      }
  },
  methods: {
    save: function() {
      if (this.id != undefined) {
        this.$store.dispatch("updateSaver", {
          title: this.$data._title,
          total: parseInt(this.$data._total),
          saved: parseInt(this.$data._saved),
          step: parseInt(this.$data._step),
          id: this.id
        });
      } else {
        this.$store.dispatch("createSaver",{
          title: this.$data._title,
          total: parseInt(this.$data._total),
          saved: parseInt(this.$data._saved),
          step: parseInt(this.$data._step)
        });
      }
      this.dialog = false;
    },
    deleteSaver: function() {
      this.$store.dispatch("deleteSaver", { id: this.id });
    }
  }
};
</script>
